import 'intersection-observer'
import {useEffect, useRef, useState} from 'react'
import useLayoutEffect from '@react-hook/passive-layout-effect'

const useIntersectionObserver = (options = {}) => {
  const {
    root = null,
    pollInterval = null,
    useMutationObserver = false,
    rootMargin = '0px 0px 0px 0px',
    threshold = 0,
    initialIsIntersecting = false,
  } = options

  function _ref(entries) {
    return setEntry(entries[entries.length - 1])
  }

  const didMount = useRef(null),
    [element, setElement] = useState(null),
    [entry, setEntry] = useState(() => ({
      boundingClientRect: null,
      intersectionRatio: 0,
      intersectionRect: null,
      isIntersecting: initialIsIntersecting,
      rootBounds: null,
      target: null,
      time: 0,
    })),
    createObserver = () => {
      if (typeof IntersectionObserver === 'undefined') return null
      const observer = new IntersectionObserver(_ref, {
        root,
        rootMargin,
        threshold,
      }) // @ts-ignore

      observer.POLL_INTERVAL = pollInterval // @ts-ignore

      observer.USE_MUTATION_OBSERVER = useMutationObserver
      return observer
    },
    [observer, setObserver] = useState(createObserver)

  useEffect(() => {
    if (didMount.current === false) didMount.current = true
    else setObserver(createObserver())
    const {current} = didMount
    return () => {
      current === true && observer && observer.disconnect()
    }
  }, [
    root,
    rootMargin,
    pollInterval,
    useMutationObserver,
    ...(Array.isArray(threshold) === true ? threshold : [threshold]),
  ])

  function _ref2() {
    element && observer && observer.unobserve(element)
  }

  useLayoutEffect(() => {
    element && observer && observer.observe(element)
    return _ref2
  }, [element, observer])
  return [entry, setElement]
}

export default useIntersectionObserver



//////////////////
// WEBPACK FOOTER
// ./node_modules/@react-hook/intersection-observer/dist/es/index.js
// module id = 479
// module chunks = 10